import { ToneBadge } from "../ui";

const REQUIRED_STATUS_RENDERINGS = [
  {
    status: "PASS",
    tone: "pass",
    reasonCode: "receipt-valid",
    source: "docs/verification/v2/golden-vectors/fixtures/receipt-valid.json",
  },
  {
    status: "FAIL",
    tone: "fail",
    reasonCode: "stale-evidence",
    source: "docs/verification/v2/golden-vectors/fixtures/stale-evidence.json",
  },
  {
    status: "UNKNOWN",
    tone: "unknown",
    reasonCode: "provider-outage",
    source: "docs/verification/v2/golden-vectors/fixtures/provider-outage.json",
  },
  {
    status: "NOT_RUN",
    tone: "neutral",
    reasonCode: "required-live-not-run",
    source: "docs/verification/v2/golden-vectors/fixtures/required-live-not-run.json",
  },
] as const;

export function RequiredStatusRenderingStrip() {
  return (
    <div className="vp-card" data-qa="workflows-required-status-rendering">
      <div className="vp-card-head">
        <div className="vp-card-title">Required outcomes</div>
      </div>
      <div className="vp-card-body">
        <div className="flex flex-wrap items-center gap-2">
          {REQUIRED_STATUS_RENDERINGS.map((rendering) => (
            <span
              key={rendering.status}
              data-workflows-required-status={rendering.status}
              data-workflows-fixture-source={rendering.source}
              data-reason-code={rendering.reasonCode}
              title={rendering.reasonCode}
            >
              <ToneBadge tone={rendering.tone}>{rendering.status}</ToneBadge>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
